import { create } from 'zustand';

interface SelectedItem {
  selectedItems: number[]; // Array of content IDs (unique across all content types)
  selectItem: (contentId: number) => void;
  unselectItem: (contentId: number) => void;
  toggleItem: (contentId: number) => void;
  selectAllItems: (contentIds: number[]) => void;
  clearSelectedItems: () => void;
  isItemSelected: (contentId: number) => boolean;
}

export const useSelectedItemStore = create<SelectedItem>((set, get) => ({
  selectedItems: [],

  selectItem: (contentId: number) =>
    set((state) => {
      if (!state.selectedItems.includes(contentId)) {
        return { selectedItems: [...state.selectedItems, contentId] };
      }
      return state;
    }),

  unselectItem: (contentId: number) =>
    set((state) => {
      return { selectedItems: state.selectedItems.filter((id) => id !== contentId) };
    }),

  toggleItem: (contentId: number) => {
    set((state) => {
      const itemExists = state.selectedItems.includes(contentId);
      const newItems = itemExists
        ? state.selectedItems.filter((id) => id !== contentId)
        : [...state.selectedItems, contentId];
      return { selectedItems: newItems };
    });
  },

  selectAllItems: (contentIds: number[]) => {
    set({ selectedItems: [...contentIds] });
  },

  clearSelectedItems: () => {
    set({ selectedItems: [] });
  },

  isItemSelected: (contentId: number) => {
    return get().selectedItems.includes(contentId);
  }
}));
